import { render, staticRenderFns } from "./COSystemsList.vue?vue&type=template&id=0db12ec4"
import script from "./COSystemsList.vue?vue&type=script&lang=js"
export * from "./COSystemsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/3e17078e833b83b1/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0db12ec4')) {
      api.createRecord('0db12ec4', component.options)
    } else {
      api.reload('0db12ec4', component.options)
    }
    module.hot.accept("./COSystemsList.vue?vue&type=template&id=0db12ec4", function () {
      api.rerender('0db12ec4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/CrossOrg/COSystemsList.vue"
export default component.exports